var a_color = 0;
var b_color = 0;
var c_color = 0;
var d_color = 0;

var compflg1 = 0
var compflg2 = 0
var compflg3 = 0
var compflg4 = 0

/* tab */
$(function() {
	$('.tab li').click(function() {
		var index = $('.tab li').index(this);
		$('.r_content_tab div.tab_list').css('display','none');
		$('.r_content_tab div.tab_list').eq(index).css('display','block');
		$('.tab li').removeClass('select');
		$(this).addClass('select')
	});
});

/* next_prev_btn */
$(function() {
	$('.next_btn').click(function() {
        var n_flg = $(this).attr('id');
        var n_flg_str = n_flg;
        n_flg_str1 = n_flg_str.substr( 4, 1 );
        
        if(n_flg_str1 == 5){
            $('#comp_box1').html('<div class="title">いろ</div><div class="box ' + comp_a_box + '"></div><div class="text">' + comp_a_text  + '</div>');
            $('#comp_box2').html('<div class="title">ふち</div><div class="box ' + comp_b_box + '"></div><div class="text">' + comp_b_text  + '</div>');
            $('#comp_box3').html('<div class="title">いと</div><div class="box ' + comp_c_box + '"></div><div class="text">' + comp_c_text  + '</div>');
            $('#comp_box4').html('<div class="title">せなか・<br>うちばり</div><div class="box ' + comp_d_box + '"></div><div class="text">' + comp_d_text  + '</div>');
        }
        
        $('.r_content_tab div.tab_list').css('display','none');
        $('.r_content_tab div.tab_list:nth-child(' + n_flg_str1 + ')').css('display','block');
        $('.tab li').removeClass('select');
        $('.tab li:nth-child(' + n_flg_str1 + ')').addClass('select');
	});
});

$(function() {
	$('.comp_btn').click(function() {
        $('.r_content_tab div.tab_list').css('display','none');
        $('.r_content_tab div.tab_list:nth-child(5)').css('display','block');
        $('.tab li').removeClass('select');
        $('.tab li:nth-child(5)').addClass('select');
        $('#comp_box1').html('<div class="title">いろ</div><div class="box ' + comp_a_box + '"></div><div class="text">' + comp_a_text  + '</div>');
        $('#comp_box2').html('<div class="title">ふち</div><div class="box ' + comp_b_box + '"></div><div class="text">' + comp_b_text  + '</div>');
        $('#comp_box3').html('<div class="title">いと</div><div class="box ' + comp_c_box + '"></div><div class="text">' + comp_c_text  + '</div>');
        $('#comp_box4').html('<div class="title">せなか・<br>うちばり</div><div class="box ' + comp_d_box + '"></div><div class="text">' + comp_d_text  + '</div>');
	});
});

$(function() {
	$('.prev_btn').click(function() {
        var n_flg = $(this).attr('id');
        var n_flg_str = n_flg;
        n_flg_str1 = n_flg_str.substr( 4, 1 );
        $('.r_content_tab div.tab_list').css('display','none');
        $('.r_content_tab div.tab_list:nth-child(' + n_flg_str1 + ')').css('display','block');
        $('.tab li').removeClass('select');
        $('.tab li:nth-child(' + n_flg_str1 + ')').addClass('select');
	});
});

/* compflg_check */
function compflg_check(){
    if(compflg1 + compflg2 + compflg3 + compflg4 == 4){
        $('#next5').css('display','block');
        //$('.comp_btn').css('display','block');
        $('.comp_btn').fadeIn(500);
    }
}

/* color_btn */
function color_func(id1,id2){
    $(function () {
        $('#box1_' + id1 + '_pre').html('<div class="r_box r_box1 f_' + id2 + str1 +'"></div>');
        $('#box1_' + id1 + '_pre').hide().fadeIn(300).queue(function(){
            $('#box1_' + id1).html('<div class="r_box r_box1 f_' + id2 + str1 +'"></div>');
            $(this).dequeue();
        });
        
        $('#box2_' + id1 + '_pre').html('<div class="r_box r_box2 in_' + id2 + str1 +'"></div>');
        $('#box2_' + id1 + '_pre').hide().fadeIn(300).queue(function(){
            $('#box2_' + id1).html('<div class="r_box  r_box2 in_' + id2 + str1 +'"></div>');
            $(this).dequeue();
        });

        $('#box3_' + id1 + '_pre').html('<div class="r_box r_box3 u_' + id2 + str1 +'"></div>');
        $('#box3_' + id1 + '_pre').hide().fadeIn(300).queue(function(){
            $('#box3_' + id1).html('<div class="r_box  r_box3 u_' + id2 + str1 +'"></div>');
            $(this).dequeue();
        });
    });
}

$(function() {
	$('.btn_area1 .btn').click(function() {
        var color_id = $(this).attr('id');
        //console.log(color_id);
        var str = color_id;
        str1 = str.substr( 1, 5 );
        str2 = str.substr( 0, 1 );
        //console.log(str1);
        if(str2 == "a"){
            if(a_color != str1){
                color_func(1,"iro")
                a_color = str1;
                if(compflg1 == 0){
                    $('.tab li:nth-child(1)').addClass('comp');
                    compflg1 = 1;
                    compflg_check()
                }
            }
        }else if(str2 == "b"){
            if(b_color != str1){
                color_func(2,"futi")
                b_color = str1;
                if(compflg2 == 0){
                    $('.tab li:nth-child(2)').addClass('comp');
                    compflg2 = 1;
                    compflg_check()
                }
            }
        }
	});
});

$(function() {
	$('.btn_area2 .btn').click(function() {
        var color_id = $(this).attr('id');
        //console.log(color_id);
        var str = color_id;
        str1 = str.substr( 1, 5 );
        str2 = str.substr( 0, 1 );
        //console.log(str1);
        if(str2 == "c"){
            if(c_color != str1){
                color_func(3,"ito")
                c_color = str1;
                if(compflg3 == 0){
                    $('.tab li:nth-child(3)').addClass('comp');
                    compflg3 = 1;
                    compflg_check()
                }
            }
        }
	});
});

$(function() {
	$('.btn_area3 .btn').click(function() {
        var color_id = $(this).attr('id');
        //console.log(color_id);
        var str = color_id;
        str1 = str.substr( 1, 5 );
        str2 = str.substr( 0, 1 );
        //console.log(str1);
        if(str2 == "d"){
            if(d_color != str1){
                color_func(4,"senaka")
                d_color = str1;
                $('.tab li:nth-child(4)').addClass('comp');
                if(compflg4 == 0){
                    $('.tab li:nth-child(4)').addClass('comp');
                    compflg4 = 1;
                    compflg_check()
                }
            }
        }
	});
});

var comp_a_text;
var comp_a_box;

function cl(id1,id2,id3){
    if(id1 == 'a'){
        $('.r_content_tab div.tab_list:nth-child(1) .btn').removeClass('box_select');
        $('.r_content_tab div.tab_list:nth-child(1) .' + id3 + '').addClass('box_select');
        comp_a_text = id2;
        comp_a_box = id3;
    }else if(id1 == 'b'){
        $('.r_content_tab div.tab_list:nth-child(2) .btn').removeClass('box_select');
        $('.r_content_tab div.tab_list:nth-child(2) .' + id3 + '').addClass('box_select');
        comp_b_text = id2;
        comp_b_box = id3;
    }else if(id1 == 'c'){
        $('.r_content_tab div.tab_list:nth-child(3) .btn').removeClass('box_select');
        $('.r_content_tab div.tab_list:nth-child(3) .' + id3 + '').addClass('box_select');
        comp_c_text = id2;
        comp_c_box = id3;
    }else if(id1 == 'd'){
        $('.r_content_tab div.tab_list:nth-child(4) .btn').removeClass('box_select');
        $('.r_content_tab div.tab_list:nth-child(4) .' + id3 + '').addClass('box_select');
        comp_d_text = id2;
        comp_d_box = id3;
    }
}


/* reset */

$(function() {
	$('#reset_btn').click(function() {
		$('.r_content_tab div.tab_list').css('display','none');
		$('.r_content_tab div.tab_list:nth-child(1)').css('display','block');
        $('.tab li:nth-child(1)').addClass('select');
        $('#next5').css('display','none');
        a_color = 0;
        b_color = 0;
        c_color = 0;
        d_color = 0;
        compflg1 = 0;
        compflg2 = 0;
        compflg3 = 0;
        compflg4 = 0;
        var r_count = 0;
        for (let i = 0; i < 4; i++) {
            r_count = r_count + 1;
            $('.r_content_tab div.tab_list:nth-child(' + r_count + ') .btn').removeClass('box_select');
            $('.tab li:nth-child(' + r_count + ')').removeClass('comp');
            $('#box1_' + r_count + '').html('');
            $('#box1_' + r_count + '_pre').html('');
            $('#box2_' + r_count + '').html('');
            $('#box2_' + r_count + '_pre').html('');
            $('#box3_' + r_count + '').html('');
            $('#box3_' + r_count + '_pre').html('');
            $('.comp_btn').css('display','none');
        }
	});
});